import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "qiubu:history";
const MAX_ITEMS = 8;

export function useHistory() {
  const [history, setHistory] = useState<string[]>([]);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) setHistory(parsed);
      }
    } catch {
      /* ignore malformed storage */
    }
  }, []);

  const add = useCallback((id: string) => {
    setHistory((prev) => {
      const next = [id, ...prev.filter((item) => item !== id)].slice(0, MAX_ITEMS);
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      } catch {
        /* ignore write failures */
      }
      return next;
    });
  }, []);

  return { history, add };
}